import { GenIcon } from 'react-icons';
export const MdAppArrowLeft = GenIcon({
    tag: 'svg',
    attr: { fill: 'none' },
    child: [
        {
            tag: 'svg',
            attr: { fill: 'none' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        d: 'M19 12H5l7 7m0-14L8 9',
                        strokeWidth: '2',
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                    },
                    child: [],
                },
            ],
        },
    ],
});
